import React from "react";
import "./VideoSection.css";

const videos = [
  "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Video-2024-08-04-at-01.21.29_3b9ea092.mp4",
  "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Video-2024-08-04-at-01.21.29_5f395421.mp4",
];

const VideoSection = () => {
  return <>
 <section className="video-section">
      {/* قسم النص التعريفي فوق الفيديوهات */}
      <div className="video-intro">
        <h2>About Realm of Herbs</h2>
        <p>
          Welcome to <strong>Realm of Herbs Co.</strong>, a premier Egyptian company
          dedicated to cultivating and exporting high-quality herbs, spices, and
          select agricultural products. For nearly two decades, our family legacy
          has driven us to grow with passion, nurturing fertile lands to bring
          the best nature has to offer.
        </p>
      </div>

      <div className="video-container">
        {videos.map((video, index) => (
          <div className="video-wrapper" key={index}>
            <video
              src={video}
              controls
              loop
              muted
              autoPlay
              className="video-item"
            ></video>
            <div className="video-overlay">
              <p>Watch our process</p>
            </div>
          </div>
        ))}
      </div>
    </section>
    </>
    };

export default VideoSection;
